import Cookies from "js-cookie";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { format } from "date-fns";

import { useDateRangeStore } from "./_components/date-range-picker/use-date-range-store";
import { convertUTCtoIST } from "@/utils";
import { getAllSalaryOfEmployeeQueryOptions } from "@/config/queries/query-options";
import { DateRangePicker } from "./_components/date-range-picker/date-range-picker2";
import { DataTable } from "./_components/salary-table/data-table";
import { ColumnDef } from "@tanstack/react-table";
import { Salary } from "./_components/salary-table/schema";
import { getColumns } from "./_components/salary-table/columns";
import { SalaryModal } from "./_components/salary-modal/salary-modal";

const EmployeeSalaries = () => {
  const key = Cookies.get("key") as string;
  const { dateRange } = useDateRangeStore();

  // const { filter, setFilter } = useStatusFilter();

  const startdate = dateRange?.from as Date;
  const enddate = dateRange?.to as Date;

  const { data, isPending, isFetching } = useQuery(
    getAllSalaryOfEmployeeQueryOptions(key, {
      start: convertUTCtoIST(new Date(startdate.setHours(0))),
      end: convertUTCtoIST(new Date(enddate.setHours(23))),
    })
  );

  const salaries = useMemo(() => {
    if (isPending) {
      return [];
    }

    if (data === undefined || data?.salary === undefined) {
      return [];
    }

    const result = data?.salary?.map((sal) => {
      return {
        employee: sal?.employee,
        employeeName: sal?.employee?.name,
        approved: sal?.approved,
        createdAt: sal?.createdAt,
        netPay: sal?.netPay,
        totalDeductions: sal?.totalDeductions,
        totalEarnings: sal?.totalEarnings,
        notes: sal?.notes,
        // period: sal?.period,
        period: `${format(new Date(sal.period.start), "PPP")} - ${format(
          new Date(sal.period.end),
          "PPP"
        )}`,
        components: sal?.components,
        id: sal?._id,
      };
    });

    return result?.sort(
      (a, b) =>
        new Date(b?.createdAt as string).getTime() -
        new Date(a?.createdAt as string).getTime()
    );
  }, [data, isPending, isFetching]);

  const columns = useMemo<ColumnDef<Salary, unknown>[]>(() => getColumns(), []);

  return (
    <div className="p-5 h-[calc(100%-56px)]">
      <div className="flex items-center justify-between">
        <h3 className="text-2xl font-medium">Salaries</h3>

        <div className="flex items-center gap-2">
          <DateRangePicker />
        </div>
      </div>

      <div className="mt-5 mb-10 pb-10">
        <DataTable data={salaries} columns={columns} />
      </div>

      <SalaryModal />
    </div>
  );
};

export default EmployeeSalaries;
